'use strict';

class FindMemberOrganisationSearch {
    constructor() {
        this.suggestionsContainer = document.querySelector("#fmo-suggestions-container");
        this.suggestionsList = document.querySelector("#fmo-suggestions");
        this.searchForm = document.querySelector("#fmo-form");        
        this.searchInput = document.querySelector("input[name=find-organisationmember]");
        this.searchOptionContainer = document.querySelector(".form__row--search-option");
        this.searchOption = document.querySelector("input[name=find-organisationmember-option]");
        this.baseUrl = this.getBaseUrl();
        this.autoCompleteCanceled = false;
        this.selectedBranch = "";
        if (this.suggestionsContainer) {
            this.searchInput.focus();
            this.currentFocus = -1;
            this.searchForm.addEventListener("submit", evt => {
                evt.preventDefault();           
                if (this.currentFocus >= 0) {
                    let suggestions = this.suggestionsList.querySelectorAll("li");
                    this.search(suggestions[this.currentFocus].innerHTML);
                } else {
                    this.search(this.searchInput.value);
                }
            });    
            this.searchInput.addEventListener("keydown", evt => {    
                this.autoCompleteCanceled = false;                
                if (evt.keyCode === 40) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.changeAutoSuggestCurrentFocus(1);
                } else if (evt.keyCode === 38) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.changeAutoSuggestCurrentFocus(-1);
                } else if (evt.keyCode === 13) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.search(this.searchInput.value);
                }
            });
            this.searchInput.addEventListener("keyup", this.delay(evt => {                      
                if (evt.keyCode === 40 || evt.keyCode === 38 || evt.keyCode === 13) {
                    return;
                } else if (evt.target.value === "") {                    
                    this.search(this.searchInput.value);
                } else if (evt.target.value.length > 0) {
                    var url = this.baseUrl + "FindSuggestions?branch=" + this.selectedBranch + "&query=" + evt.target.value;
                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            if (!this.autoCompleteCanceled) {
                                this.initAutoSuggest(data.suggestions);
                            }
                        }
                    );
                }
            }, 500));
            this.searchInput.addEventListener("search", evt => {
                evt.preventDefault();                
                this.search(this.searchInput.value);
            });
            this.searchOption.addEventListener("change", evt => {
                evt.preventDefault();
                if (this.searchInput.value !== "") {
                    this.search(this.searchInput.value);
                }
            });
            document.addEventListener("fmo.resultLoaded", evt => {                
                var nonConcurrentGeoMatch = evt.detail.nonConcurrentGeoMatch;
                if (nonConcurrentGeoMatch && this.searchInput.value !== "") {
                    this.searchOptionContainer.classList.remove("hidden");
                    this.searchOptionContainer.querySelector("label").textContent = "Menade du endast företag i " + this.searchInput.value.charAt(0).toUpperCase() + this.searchInput.value.slice(1).toLowerCase() + "?";
                } else {
                    this.searchOptionContainer.classList.add("hidden");
                }
            });
            document.addEventListener("fmo.resultReset", evt => {
                this.searchOptionContainer.classList.add("hidden");
                this.searchOption.checked = false;
            });
            document.addEventListener("fmo.branchSelected", evt => {
                this.selectedBranch = evt.detail.branch;                
            });
        }
    }
    getBaseUrl() {
        const url = window.location.href.split('?')[0];
        return url.endsWith("/") ? url : `${url}/`;
    }
    initAutoSuggest(suggestions) {
        this.currentFocus = -1;
        this.suggestionsList.innerHTML = "";

        if (Object.keys(suggestions).length > 0) {
            this.suggestionsContainer.classList.add("active");

            [].forEach.call(suggestions, suggestion => {
                let suggestionName = suggestion.value;
                let suggestionValue = suggestion.key;
                var li = document.createElement("li");
                li.innerHTML = suggestionName;                
                li.dataset.value = suggestionValue;
                this.suggestionsList.appendChild(li);
                li.addEventListener("click", evt => {
                    evt.preventDefault();
                    this.search(evt.target.innerHTML);
                });
            });
        } else {
            var noli = document.createElement("li");
            noli.classList.add("no-suggestion");
            noli.innerHTML = "Inget förslag hittades";
            this.suggestionsList.appendChild(noli);
        }
    }
    changeAutoSuggestCurrentFocus(change) {
        this.currentFocus += change;
        let suggestions = this.suggestionsList.querySelectorAll("li");
        [].forEach.call(suggestions, suggestion => {
            suggestion.classList.remove("active");
        });
        if (this.currentFocus < -1) {
            this.currentFocus = -1;
        } else if (this.currentFocus > suggestions.length - 1) {
            this.currentFocus = suggestions.length - 1;
        }
        if (this.currentFocus >= 0) {
            suggestions[this.currentFocus].classList.add("active");
        }
        this.searchInput.value = this.decodeHTML(suggestions[this.currentFocus].innerHTML);
    }    
    search(query) {        
        this.autoCompleteCanceled = true;
        document.dispatchEvent(new CustomEvent("fmo.searchTriggered", {
            detail: { query: query, onlygeo: this.searchOption.checked }
        }));        
        this.reset();
    }
    reset() {
        this.currentFocus = -1;
        this.initAutoSuggest([]);
        this.suggestionsContainer.classList.remove("active");
        document.dispatchEvent(new CustomEvent("fmo.suggestionReset"));
    }
    delay(callback, ms) {
        var timer = 0;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }
    decodeHTML(html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new FindMemberOrganisationSearch();
});